import React from "react";
import "./Home.css";

import slide1 from "../../assets/images/001.jpg";
import slide2 from "../../assets/images/002.jpg";
import slide4 from "../../assets/images/003.jpg";

import pdfFile from "../../assets/docs/Conference Broucher_ICIITCEE_Jan 2027-updated.pdf";
import pdf from "../../assets/docs/Hotels Near by BNMIT.pdf";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const Home = () => {
  return (
    <div className="Home">

      {/* HERO SECTION */}

      <div className="carousel-wrapper">

        <Carousel
          autoPlay
          infiniteLoop
          swipeable
          showThumbs={false}
          showStatus={false}
          interval={3500}
          transitionTime={1000}
          stopOnHover={false}
        >

          <div className="slide">
            <img src={slide1} alt="Conference Banner" />
          </div>

          <div className="slide">
            <img src={slide2} alt="Conference Banner" />
          </div>

          <div className="slide">
            <img src={slide4} alt="Conference Banner" />
          </div>

        </Carousel>
      
        {/* HERO OVERLAY */}

        <div className="hero-overlay">

          <p className="conference-tag">
            International Conference 2027
          </p>

          <h1>
            Welcome to
            <span className="gradient-text">
              {" "}IITCEE 2027
            </span>
          </h1>

          <p className="hero-description">
            5th International Conference on Intelligent
            and Innovative Technologies in Computing,
            Electrical and Electronics
          </p>

          <div className="hero-buttons">

            <a
              href={pdfFile}
              target="_blank"
              rel="noopener noreferrer"
              className="hero-btn primary-btn"
            >
              <h4>Download Brochure</h4>
            </a>

          </div>

        </div>

      </div>

      {/* MAIN CONTENT */}
 <div className="about-conference">
          <div className="arrange">
            <div className="text">
              <h2 className="international-Conference">
                5<sup>th</sup> International Conference on Intelligent and Innovative Technologies in Computing, Electrical and Electronics - ICIITCEE 2027, <br/>
                Jan 21-22

              </h2>
            </div>
       
          </div>
          </div>

            

      <div className="home-content">

        {/* TOP INFO */}

        <div className="top-info-section">

          <div className="info-card">

            <h1>Conference Guidelines:</h1>

            <ul>

              <li>
                - Conference will be conducted in physical mode only
              </li>

              <li>
                - Online presentations will not be permitted
              </li>

              <li>
                - Double blind review process will be followed
              </li>

            </ul>

          </div>

          <div className="info-card">

            <h2>Previous Conferences</h2>

            <div className="conference-links">

              <a
                href="https://iitcee2026.bnmit.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                ICIITCEE 2026
              </a>

              <a
                href="https://ieeexplore.ieee.org/search/searchresult.jsp?newsearch=true&queryText=iitcee%202025"
                target="_blank"
                rel="noopener noreferrer"
              >
                ICIITCEE 2025
              </a>

              <a
                href="https://ieeexplore.ieee.org/search/searchresult.jsp?newsearch=true&queryText=iitcee%202024"
                target="_blank"
                rel="noopener noreferrer"
              >
                ICIITCEE 2024
              </a>

            </div>

          </div>

          <div className="info-card">

            <h3>ICIITCEE 2026 Proceedings</h3>

            <p className="blink-text">
              IEEE Proceedings Published Successfully
            </p>

            <p>
              DOI: 10.1109/IITCEE67948.2026
            </p>

            <a
              href="https://ieeexplore.ieee.org/xpl/conhome/11393926/proceeding"
              target="_blank"
              rel="noopener noreferrer"
              className="proceeding-link"
            >
              View Proceedings
            </a>

          </div>

        </div>

        {/* DOWNLOAD BUTTONS 

        <div className="download-buttons">

          <a
            href={pdfFile}
            target="_blank"
            rel="noopener noreferrer"
            className="btn download-btn"
          >
            Conference Brochure
          </a>

          <a
            href={pdf}
            target="_blank"
            rel="noopener noreferrer"
            className="btn download-btn"
          >
            Accommodation Details
          </a>

        </div>

        {/* STATISTICS */}

        <div className="stats-section">

          <div className="stat-card">
            <h2>1800+</h2>
            <p>Papers Submitted</p>
          </div>

          <div className="stat-card">
            <h2>566</h2>
            <p>Papers Accepted</p>
          </div>

          <div className="stat-card">
            <h2>295</h2>
            <p>Papers Published</p>
          </div>

          <div className="stat-card">
            <h2>Global</h2>
            <p>Participation</p>
          </div>

        </div>

        {/* ABOUT */}

     
        <div className="about-conference">
          <div className="arrange">
            <div className="text">
              <h2 className="international-Conference">
                
           <p>
The Microsoft CMT service was used for managing the peer-reviewing process for this conference. This service was provided for free by Microsoft and they bore all expenses, including costs for Azure cloud services as well as for software development and support.
</p>

                5<sup>th</sup> International Conference on Intelligent and Innovative Technologies in Computing, Electrical and Electronics - ICIITCEE 2027, Jan 21-22

              </h2>
            </div>
       
          </div>
          <p>
            International Conference on Intelligent and Innovative Technologies in
                        Computing, Electrical and
                        Electronics (ICIITCEE 2027) is organized and hosted by BNM Institute of Technology, Bengaluru, India
                        on 21 and 22 January 2027. This conference will feature a comprehensive technical program including
                        several special sessions and workshops. The goal of ICIITCEE 2026 is to provide an outstanding forum
                        for academicians, researchers, practitioners, policymakers and students to exchange ideas,
                        techniques and tools, raise awareness, and share experiences related to all practical and
                        theoretical aspects of intelligence and innovations in engineering. 
           
          </p>

          <p style={{ textAlign: "justify" }}>
         <h4><b>Legacy of ICIITCEE- A Journey of Excellence</b></h4>
BNM Institute of Technology (BNMIT), Bengaluru, has been consistently organizing the  International Conference on Intelligent and Innovative Technologies in Computing, Electrical and Electronics (ICIITCEE) every January for the past four years. Over successive editions, ICIITCEE has emerged as a flagship  international conference, recognized for its technical quality, global participation, and strong organizational framework. Since its inception, ICIITCEE has evolved into a premier international forum, attracting researchers, academicians, industry professionals, and students from across the world. Each edition has successfully provided a vibrant platform for knowledge exchange, innovation dissemination, and collaborative networking in the rapidly advancing domains of Computing, Electrical, and Electronics Engineering. The conference has successfully completed four consecutive international editions, demonstrating strong continuity, organizational excellence, and adherence to high technical and ethical standards. The past editions witnessed robust international participation, featured keynote talks by eminent academicians, industry leaders, and distinguished speakers, and included peer-reviewed technical sessions, special sessions, and workshops covering emerging and interdisciplinary research areas.
<p>
 <b> "ICIITCEE 2025, held on 16–17 January 2025, received funding of ₹2,00,000 from the AICTE GOC scheme, which significantly enhanced the quality of the conference and contributed to its subsequent global recognition."</b>
</p>
<p><b>Success of ICIITCEE 2026 (4th Edition)</b></p>
The 4th  International Conference on ICIITCEE 2026, held on 22nd and 24th January 2026 at BNMIT, Bengaluru, marked a significant milestone in the conference series.

          </p>
          <ul style={{ marginLeft: "2rem", listStyleType: "disc", fontSize: "1.5rem" }}>
  <li>
    The conference received an overwhelming global response from researchers, academicians, and industry professionals.
  </li>
  <li>
   More than 1800 papers were submitted and a total of 566 high-quality research papers were accepted, and 295 papers were presented, and published , reflecting the conference’s academic rigor and global reach.
  </li>
  <li>
    The event served as a strong convergence point for theoretical insights, practical innovations, and emerging technologies in Computing, Electrical, and Electronics.
  </li>
  <li>
    The success of ICIITCEE 2026 reinforced BNMIT’s capability to host large-scale, impactful  conferences.
  </li>
</ul>
<br />
          <p>
            Encouraged by the grand success of the previous four editions, BNMIT is proud to announce the 5th International Conference on ICIITCEE 2027, scheduled to be held on 21st and 22nd January 2027. ICIITCEE 2027 aims to further strengthen its legacy by offering a comprehensive technical program comprising paper presentations, special sessions, and workshops to exchange ideas, techniques, research experience and best practices providing an outstanding platform for academicians, researchers, practitioners, policymakers, and students to exchange ideas, share experiences, and discuss emerging challenges and solutions.
ICIITCEE focuses on Intelligent and Innovative Technologies in Computing, Electrical, and Electronics, fields that are evolving rapidly and influencing every aspect of modern society.
</p>
<p><b>Objectives of the Conference:</b>
<ul style={{ marginLeft: "1rem", listStyleType: "disc" }}>
  <li>To provide a common platform for stakeholders to share ideas, innovations, and recent research findings.</li>
  <li>To strengthen collaboration between academia and industry at regional, national, and international levels.</li>
  <li>To enable students and early-career researchers to interact, learn, and network with experts.</li>
  <li>To bridge the gap between industry and academia through meaningful technical interactions.</li>
  <li>To promote high-level discussions and knowledge exchange in theoretical, experimental, and applied engineering domains.</li>
</ul>


          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;

